var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.authTipsOpen && false,
          expression: "authTipsOpen && false"
        }
      ],
      staticClass: "page-auth-tips",
      style: { position: _vm.local ? "relative" : "fixed" }
    },
    [
      _c(
        "div",
        { staticClass: "page-auth-tips-content" },
        [
          _c("p", { staticStyle: { "margin-right": "40px" } }, [
            _vm._v(
              "依照国家《电子签名法》及《电子认证服务管理办法》相关要求，身份资料不完善，将无法使用电子签约服务！您的身份认证资料不完整，为不影响业务正常开展，请您在2025年1月16日前，及时完善资料。"
            )
          ]),
          _c(
            "el-button",
            { staticClass: "btn-sty", on: { click: _vm.openAuthVisible } },
            [
              _vm._v("立即完善资料 "),
              _c("i", { staticClass: "el-icon-d-arrow-right" })
            ]
          ),
          _c(
            "div",
            { staticClass: "auth-tips-close", on: { click: _vm.closeAuth } },
            [_c("i", { staticClass: "el-icon-close" })]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.authTipsOpen,
            title: "提示！",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            width: "450px",
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.authTipsOpen = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.openAuthVisible }
                        },
                        [_vm._v("\n          立即完善资料 >>\n        ")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", [
            _vm._v("\n      即日起，依照国家"),
            _c("span", { staticStyle: { color: "#ec1c1c" } }, [
              _vm._v("《电子签名法》")
            ]),
            _vm._v("及"),
            _c("span", { staticStyle: { color: "#ec1c1c" } }, [
              _vm._v("《电子认证服务管理办法》")
            ]),
            _vm._v(
              "相关要求，身份资料不完善，将无法使用电子签约服务！您的身份认证资料不完整，为不影响业务正常开展，请您及时完善资料。\n    "
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "企业完善认证提示",
            "append-to-body": "",
            visible: _vm.entAuthDialogVisible,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.entAuthDialogVisible = $event
            },
            close: _vm.handleEntClose
          }
        },
        [
          _c(
            "div",
            { staticClass: "info-box" },
            [
              _c(
                "el-form",
                {
                  ref: "entFrm",
                  attrs: { "label-width": "180px", model: _vm.entFrm }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "企业名称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { disabled: true, placeholder: "请输入姓名" },
                        model: {
                          value: _vm.entFrm.enterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.entFrm, "enterpriseName", $$v)
                          },
                          expression: "entFrm.enterpriseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "证件号码" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          placeholder: "请输入身份证号",
                          disabled: true
                        },
                        model: {
                          value: _vm.entFrm.businessLicenseNo,
                          callback: function($$v) {
                            _vm.$set(_vm.entFrm, "businessLicenseNo", $$v)
                          },
                          expression: "entFrm.businessLicenseNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传营业执照扫描件", required: "" } },
                    [
                      _c("p", { staticClass: "txt" }, [
                        _vm._v(
                          "请确保上传证件图片完整不缺角，光线亮度均匀无反光，照片内容清晰可见易识别"
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action: "#",
                            "show-file-list": false,
                            "on-success": function(response, file, fileList) {
                              return _vm.handleIdeCareSuccess(
                                response,
                                file,
                                fileList,
                                "businessLicenseImg"
                              )
                            },
                            "before-upload": function(file) {
                              return _vm.beforeIdeCareUpload(
                                file,
                                "businessLicenseImg"
                              )
                            }
                          }
                        },
                        [
                          _vm.entFrm.businessLicenseImg.url
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: {
                                  src: _vm.entFrm.businessLicenseImg.url
                                }
                              })
                            : _c("i", {
                                staticClass: "el-icon-plus avatar-uploader-icon"
                              })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "法人姓名" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          disabled: true,
                          placeholder: "请输入法定代表人姓名"
                        },
                        model: {
                          value: _vm.entFrm.enterpriseController,
                          callback: function($$v) {
                            _vm.$set(_vm.entFrm, "enterpriseController", $$v)
                          },
                          expression: "entFrm.enterpriseController"
                        }
                      })
                    ],
                    1
                  ),
                  false && _vm.identityReplenishAuth === 2
                    ? [
                        _c("el-divider"),
                        _c(
                          "el-form-item",
                          { attrs: { label: "被授权人" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: {
                                disabled: true,
                                placeholder: "请输入被授权人"
                              },
                              model: {
                                value: _vm.entFrm.enterpriseController11,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.entFrm,
                                    "enterpriseController11",
                                    $$v
                                  )
                                },
                                expression: "entFrm.enterpriseController11"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "被授权人证件号" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: {
                                placeholder: "请输入被授权人证件号",
                                disabled: true
                              },
                              model: {
                                value: _vm.entFrm.IDCard11,
                                callback: function($$v) {
                                  _vm.$set(_vm.entFrm, "IDCard11", $$v)
                                },
                                expression: "entFrm.IDCard11"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "上传被授权人身份证图片",
                              required: ""
                            }
                          },
                          [
                            _c("p", { staticClass: "txt" }, [
                              _vm._v(
                                "请确保上传证件图片完整不缺角，光线亮度均匀无反光，照片内容清晰可见易识别"
                              )
                            ])
                          ]
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  action: "#",
                                  "show-file-list": false,
                                  "on-success": function(
                                    response,
                                    file,
                                    fileList
                                  ) {
                                    return _vm.handleIdeCareSuccess(
                                      response,
                                      file,
                                      fileList,
                                      "authorizationFront"
                                    )
                                  },
                                  "before-upload": function(file) {
                                    return _vm.beforeIdeCareUpload(
                                      file,
                                      "authorizationFront"
                                    )
                                  }
                                }
                              },
                              [
                                _vm.entFrm.authorizationFront.url
                                  ? _c("img", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: _vm.entFrm.authorizationFront.url
                                      }
                                    })
                                  : [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon"
                                      }),
                                      _c("p", { staticClass: "upload-tit" }, [
                                        _vm._v("正面")
                                      ])
                                    ]
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  action: "#",
                                  "show-file-list": false,
                                  "on-success": function(
                                    response,
                                    file,
                                    fileList
                                  ) {
                                    return _vm.handleIdeCareSuccess(
                                      response,
                                      file,
                                      fileList,
                                      "authorizationVerso"
                                    )
                                  },
                                  "before-upload": function(file) {
                                    return _vm.beforeIdeCareUpload(
                                      file,
                                      "authorizationVerso"
                                    )
                                  }
                                }
                              },
                              [
                                _vm.entFrm.authorizationVerso.url
                                  ? _c("img", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: _vm.entFrm.authorizationVerso.url
                                      }
                                    })
                                  : [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon"
                                      }),
                                      _c("p", { staticClass: "upload-tit" }, [
                                        _vm._v("反面")
                                      ])
                                    ]
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "上传授权书" } },
                          [
                            _c("p", [
                              _c(
                                "a",
                                {
                                  staticClass: "downFile",
                                  attrs: { href: "javascript: void(0);" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadApplyFile()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "xia" }),
                                  _vm._v("下载授权书")
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "400",
                                    color: "rgba(0,0,0,0.45)"
                                  }
                                },
                                [_vm._v("（打印盖章）")]
                              )
                            ]),
                            _c(
                              "el-upload",
                              {
                                staticClass: "uploadFileBtn",
                                attrs: {
                                  action: "#",
                                  "show-file-list": false,
                                  "on-success": function(
                                    response,
                                    file,
                                    fileList
                                  ) {
                                    return _vm.handleIdeCareSuccess(
                                      response,
                                      file,
                                      fileList,
                                      "agentAttorneyCard"
                                    )
                                  },
                                  "before-upload": function(file) {
                                    return _vm.beforeIdeCareUpload(
                                      file,
                                      "agentAttorneyCard"
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "shang" }),
                                _vm._v("上传授权书\n            ")
                              ]
                            ),
                            _c("span", [
                              _c(
                                "b",
                                { staticStyle: { "margin-left": "10px" } },
                                [_vm._v(_vm._s(_vm.filename))]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "400",
                                    color: "rgba(0,0,0,0.45)"
                                  }
                                },
                                [_vm._v("（支持jpg、png格式、扫描件）")]
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.entAuthDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.entFrmSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "个人完善认证提示",
            "append-to-body": "",
            visible: _vm.personalAuthDialogVisible,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.personalAuthDialogVisible = $event
            },
            close: _vm.handlePersonalClose
          }
        },
        [
          _c(
            "div",
            { staticClass: "info-box" },
            [
              _c(
                "el-form",
                {
                  ref: "personalFrm",
                  attrs: { "label-width": "140px", model: _vm.personalFrm }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { disabled: true, placeholder: "请输入姓名" },
                        model: {
                          value: _vm.personalFrm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.personalFrm, "name", $$v)
                          },
                          expression: "personalFrm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证号", prop: "identityNo" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          disabled: true,
                          placeholder: "请输入身份证号"
                        },
                        model: {
                          value: _vm.personalFrm.identityNo,
                          callback: function($$v) {
                            _vm.$set(_vm.personalFrm, "identityNo", $$v)
                          },
                          expression: "personalFrm.identityNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传证件照片", required: "" } },
                    [
                      _c("p", { staticClass: "txt" }, [
                        _vm._v(
                          "请确保上传证件图片完整不缺角，光线亮度均匀无反光，照片内容清晰可见易识别"
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action: "#",
                            name: "personalFront",
                            "show-file-list": false,
                            "on-success": function(response, file, fileList) {
                              return _vm.handleIdeCareSuccess(
                                response,
                                file,
                                fileList,
                                "personalFront"
                              )
                            },
                            "before-upload": function(file) {
                              return _vm.beforeIdeCareUpload(
                                file,
                                "personalFront"
                              )
                            }
                          }
                        },
                        [
                          _vm.personalFrm.personalFront.url
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: {
                                  src: _vm.personalFrm.personalFront.url
                                }
                              })
                            : [
                                _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon"
                                }),
                                _c("p", { staticClass: "upload-tit" }, [
                                  _vm._v("正面")
                                ])
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action: "#",
                            "show-file-list": false,
                            "on-success": function(response, file, fileList) {
                              return _vm.handleIdeCareSuccess(
                                response,
                                file,
                                fileList,
                                "personalVerso"
                              )
                            },
                            "before-upload": function(file) {
                              return _vm.beforeIdeCareUpload(
                                file,
                                "personalVerso"
                              )
                            }
                          }
                        },
                        [
                          _vm.personalFrm.personalVerso.url
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: {
                                  src: _vm.personalFrm.personalVerso.url
                                }
                              })
                            : [
                                _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon"
                                }),
                                _c("p", { staticClass: "upload-tit" }, [
                                  _vm._v("反面")
                                ])
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.personalAuthDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.personalFrmSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-faa20df6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faa20df6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/authentication-tips/index.vue
// module id = EErE
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37